////////LIBRARY/////////
import React, { useState, useEffect, Fragment } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { cloneDeep, map, reduce, isUndefined, reject, isEmpty, find } from 'lodash'
import moment from 'moment'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import Button from '../Ui/Buttons'
import theme from '../../theme/theme'
import ToggleFilters from '../Ui/ToggleFilters'
import { PageTitle, PageWrapperActionValidate, ButtonWrapper, InputLogin, ErrorInputMsg } from '../../theme/GlobalCss'
import ImgButton from '../Ui/ImgButton'
import UseDatePicker from '../../hooks/UseDatePicker'
import { campaignPromoActionCreators } from '../../store/actions'
import { selectIdsUser } from '../../store/selectors/user'
import Modals from '../Modals'
import Table from '../Table'
import PromoCampaignCreationSecondLine from './PromoCampaignCreationSecondLine'
/////////ASSETS/////////
import Calendar from '../../assets/icones/global/calendar.svg'
import Validation from '../../assets/icones/global/check.svg'
import Cancel from '../../assets/icones/global/close-white.svg'

/////////STYLED/////////
const PromoCampaignWrapper = styled.div`
	position: relative;
`
const PromoCampaignHeader = styled.div`
	display: flex;
	& > :first-child {
		margin: 0px 15px 0px 0px;
	}
	& > * {
		top: 0px !important;
	}
	& > :last-child {
		margin-left: 25px;
	}
	margin-bottom: 15px;
	align-items: center;
	justify-content: space-between;
`
const PromoHeaderLeftSide = styled.div`
	display: flex;
	justify-content: flex-start;
	& > * {
		margin-right: 30px;
	}
`
const PromoHeaderRightSide = styled.div`
	display: flex;
	justify-content: flex-end;
`
const ButtonSize = styled.div`
	display: flex;
	height: 32px;
	width: max-content;
`
const PromoCampaignFilters = styled.div`
	position: relative;
	padding-right: 17px;
	& > * {
		margin: 0px 7px;
	}
	& > :first-child img {
		max-height: 24px;
		margin: 0px 10px 0px 0px;
	}
	display: flex;
	flex-direction: row;
`
const PromoCampaignContent = styled.div`
	overflow: auto;
	padding: 0px 30px;
	background-color: #f1f1f1;
`
const PromoCampaignInputDate = styled.div`
	display: flex;
	& p {
		margin: 0;
	}
	align-items: center;
`
const PromoCampaignInputName = styled.div`
	display: flex;
	& p {
		margin: 0px 15px 0px 0px;
	}
	align-items: center;
`
const DatePickerWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`
const DatePickerCampaignIcon = styled.div`
	border-radius: 4px;
	background-color: ${(props) => props.theme.colors.primary};
	height: 32px;
	width: 32px;
	padding: 6px;
	box-sizing: border-box;
	cursor: pointer;
	background-image: url(${Calendar});
	background-repeat: no-repeat;
	background-size: 20px 20px;
	background-position: center;
	margin: 0px 8px 0px 15px;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const SpanDelete = styled.span`
	cursor: pointer;
`
const ModalText = styled.div`
	display: flex;
	justify-content: center;
	align-content: center;
`
const ModalListKiosksName = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 10px;
	overflow: auto;
	background-color: #f5f6fa;
	margin: 20px 0;
`
const PageWrapperActions = styled.div`
	display: flex;
	flex-direction: row-reverse;
`
/////////STYLED/////////

const PromoCampaignHandlerCreate = (props) => {
	const [data, setData] = useState({})

	const [stateDefaultValues, setStateDefaultValues] = useState({
		campaignName: '',
	})

	const [widthTaxes, setWidthTaxes] = useState(props.widthTaxes)

	const [sendConfirm, setSendConfirm] = useState(false)

	const campaignPromoActions = bindActionCreators(campaignPromoActionCreators, useDispatch())

	const { translations, userIds, campaignPromo } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			userIds: selectIdsUser(state),
			campaignPromo: state.campaignPromo.campaign,
		}),
		shallowEqual
	)

	const { register, handleSubmit, errors, setValue, getValues } = useForm({
		mode: 'onChange',
		defaultValues: stateDefaultValues,
	})

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleDeleteLine = (id) => {
		const dataCP = cloneDeep(data)
		if (dataCP.priceCampaignLines.length === 1) return // guard to delete last line
		dataCP.priceCampaignLines = reject(dataCP.priceCampaignLines, { idItem: id })
		setData(dataCP)
	}

	const [dateCampaignShowModal, dateCampaignOpenDateModalHandler, dateCampaignRenderModal, dateCampaignStateDate, setStartDate, setEndDate] =
		UseDatePicker({
			defaultDateStart: moment().add(15, 'minutes').toDate(),
			defaultDateEnd: moment().add(1, 'week').toDate(),
			noPastDate: true,
			ifCancel: true,
			step: true,
			insideModal: true,
		})

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const updateMode = props.updateMode || false
	const [columns, setColumns] = useState()

	const config = {
		name: '',
		fixedColumnSelection: true,
		isUpdateCampaign: updateMode,
		isCampaign: true,
		campaignValues: {
			campaignComponent: PromoCampaignCreationSecondLine,
		},
		noWindowing: true,
	}

	const handleWithTTC = () => {
		setWidthTaxes((prevState) => !prevState)
	}

	const onErrors = () => {
		setSendConfirm(false)
	}

	const onSubmit = (submittedData) => {
		const updatedData = cloneDeep(submittedData)

		updatedData.priceValue = map(data.priceCampaignLines, (elem) => ({
			...submittedData.priceValue[elem.lineNumber],
			idItem: elem.idItem,
			idKiosk: elem.idKiosk,
		}))

		campaignPromoActions.createCampaignPromo(
			{
				campaignName: submittedData.campaignName,
				dateStart: moment(dateCampaignStateDate.date.startDate).toDate(),
				dateEnd: moment(dateCampaignStateDate.date.endDate).toDate(),
				toApplyNow: false,
				withTTC: widthTaxes,
				idDistributor: data.idDistributor,
				itemsPrices: reduce(
					updatedData.priceValue,
					(result, elem) => {
						!isUndefined(elem) &&
							elem.idItem &&
							result.push({
								idItem: Number(elem.idItem),
								idKiosk: Number(elem.idKiosk) || null,
								standardPrice: Number(elem.actualStandardPrice),
								depositPrice: !isUndefined(elem.actualDepositPrice) ? Number(elem.actualDepositPrice) : null,
								quantity: Number(elem.quantity),
							})
						return result
					},
					[]
				),
				kioskstoUpdate: userIds.kiosksPoolSelectedIds,
			},
			props.target
		)
		setSendConfirm(false)
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!props.successCreateCampaign) return
		props.closeModalHandler()
	}, [props.successCreateCampaign])

	useEffect(() => {
		return function cleanUp() {
			setStateDefaultValues({ campaignName: '' })
			setSendConfirm(false)
			setData({ undefined })
			campaignPromoActions.resetCampaignPromo()
		}
	}, [])

	useEffect(() => {
		if (isUndefined(data)) return

		if (data?.label?.length > 0) {
			setValue('campaignName', data.label)
			setStateDefaultValues(getValues())
		}

		setColumns([
			{
				titleColumnCampaign: true,
				widthTaxes: widthTaxes,
				errors: errors,
				currency: data.currency,
				callErrors: props.campaignErrors,
				register: register,
				component: () => <div>{translations['page__promotionManagement__creation_table_actualValues']}</div>,
			},
			{ dataHook: 'kioskCode', headerName: translations['page__promotionManagement__tableHeader_expand_kioskCode'], sortable: true },
			{ dataHook: 'store', headerName: translations['page__promotionManagement__tableHeader_expand_store'], sortable: true },
			{
				dataHook: 'itemFamily.translationKey',
				headerName: translations['page__promotionManagement__tableHeader_expand_family'],
				sortable: true,
				isAuthorize: true,
				toTranslate: true,
			},
			{
				dataHook: 'itemBrand.label',
				headerName: translations['page__promotionManagement__creation_tableHeader_brand'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: 'label',
				headerName: translations['page__promotionManagement__creation_tableHeader_product'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: widthTaxes ? 'actualStandardPriceTTC' : 'actualStandardPriceHT',
				headerName: translations['page__promotionManagement__creation_tableHeader_itemPrice'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: widthTaxes ? 'actualStandardPriceHT' : 'actualStandardPriceTTC',
				headerName: translations['page__promotionManagement__creation_tableHeader_convert'],
				sortable: true,
				isAuthorize: true,
			},
			{
				dataHook: widthTaxes ? 'actualDepositPriceTTC' : 'actualDepositPriceHT',
				headerName: translations['page__promotionManagement__creation_tableHeader_depositPrice'],
				sortable: true,
				isAuthorize: true,
			},
			{ dataHook: 'available', headerName: translations['page__promotionManagement__creation_tableHeader_availableStock'], sortable: true },
			{ dataHook: 'capacity', headerName: translations['page__promotionManagement__creation_tableHeader_capacity'], sortable: true },
			{ action: true, component: (_props) => <SpanDelete onClick={() => handleDeleteLine(_props.row.idItem)}>X</SpanDelete> },
		])
	}, [data, widthTaxes])

	useEffect(() => {
		if (isEmpty(campaignPromo)) return // guard to set row on reset campaignPromo
		setData({
			kiosks: campaignPromo.Kiosks,
			priceCampaignLines: campaignPromo.Items,
			currency: campaignPromo.currency,
			label: '',
			dateStart: null,
			idDistributor:
				find(props.filters.filtersSelection.distributors.filterElements, { active: true }).id ||
				props.filters.filtersSelection.distributors.filterElements[0].id,
		})
	}, [campaignPromo])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Modals closeModalHandler={props.closeModalHandler} showModal={props.showModal} minWidth={1200}>
			<Modals
				showModal={sendConfirm}
				closeModalHandler={() => setSendConfirm(false)}
				title={translations['modal__pricesManagement__pricesCampaign_validation_title']}
				level={'error'}
				insideModalResponse={true}
				insideModal
				maxWidth={555}
				icon={true}
			>
				<ModalText>
					{!isUndefined(data?.kiosks) &&
						`${translations['modal__promotionManagement__validation_message_start']} 
							${data?.kiosks.length} 
							${translations['modal__promotionManagement__validation_message_end']}`}
				</ModalText>
				<ModalListKiosksName>{!isUndefined(data) && map(data.kiosks, (elem, id) => <p key={id}>{elem.kioskName}</p>)}</ModalListKiosksName>

				<ButtonWrapper>
					<Button
						bgColor={theme.colors.error}
						actionHandler={() => setSendConfirm(false)}
						text={translations['common__text__cancel']}
						img={Cancel}
						width={150}
					/>
					<Button
						text={translations['modal__promotionManagement__validation_button_valid']}
						actionHandler={handleSubmit(onSubmit, onErrors)}
						bgColor={theme.colors.validation}
						img={Validation}
						width={270}
						noHash
					/>
				</ButtonWrapper>
			</Modals>
			{dateCampaignRenderModal()}
			<PromoCampaignWrapper>
				<form onSubmit={handleSubmit(onSubmit, onErrors)}>
					<PromoCampaignHeader>
						<PromoHeaderLeftSide>
							<PageTitle> {translations['page__promotionManagement__creation_title']}</PageTitle>
							{
								// ( updateMode ) &&
								<>
									<PromoCampaignInputDate>
										<PageTitle>{translations['page__promotionManagement__creation_table_date']}</PageTitle>
										<DatePickerCampaignIcon onClick={dateCampaignOpenDateModalHandler} />
										<DatePickerWrapper>
											<PageTitle>{`${moment(dateCampaignStateDate.date.startDate).format('DD/MM/YYYY')}`}</PageTitle>
											<span>&nbsp;{'à'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.startDate).format('HH:mm')}`}</PageTitle>
											<span>&nbsp;{'au'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.endDate).format('DD/MM/YYYY')}`}</PageTitle>
											<span>&nbsp;{'à'}&nbsp;</span>
											<PageTitle>{`${moment(dateCampaignStateDate.date.endDate).format('HH:mm')}`}</PageTitle>
										</DatePickerWrapper>
									</PromoCampaignInputDate>
									<PromoCampaignInputName>
										<PageTitle>{translations['page__promotionManagement__creation_table_name']}</PageTitle>
										<InputLogin
											name="campaignName"
											type="text"
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 100,
													message: `100 ${translations['common__text__charMax']}`,
												},
											})}
										/>
										{errors.campaignName && <ErrorInputMsg>{errors.campaignName.message}</ErrorInputMsg>}
									</PromoCampaignInputName>
								</>
							}
						</PromoHeaderLeftSide>
						<PromoHeaderRightSide>
							<Fragment>
								{!updateMode && (
									<PromoCampaignFilters>
										<ButtonSize>
											<ToggleFilters
												checked={widthTaxes}
												onChangeHandler={handleWithTTC}
												size={'large'}
												name="withTTC"
												labelPrev={translations['page__global__admin__header_priceSwitch_priceHT']}
												labelNext={translations['page__global__admin__header_priceSwitch_priceTTC']}
											/>
										</ButtonSize>
									</PromoCampaignFilters>
								)}
							</Fragment>
							<PageWrapperActions>
								<PageWrapperActionValidate unlocked as={'div'} onClick={() => setSendConfirm(true)} />
								<ImgButton
									img={Cancel}
									action={() => props.closeModalHandler()}
									color={theme.colors.error}
									margin={'5px'}
									hover={theme.colors.hoverError}
								/>
							</PageWrapperActions>
						</PromoHeaderRightSide>
					</PromoCampaignHeader>
					<PromoCampaignContent>
						{translations && !isUndefined(data) && !isUndefined(columns) && (
							<Table inputColumns={columns} inputData={data.priceCampaignLines} inputConfig={config} />
						)}
					</PromoCampaignContent>
				</form>
			</PromoCampaignWrapper>
		</Modals>
	)
}

PromoCampaignHandlerCreate.propTypes = {}
PromoCampaignHandlerCreate.defaultPropTypes = {}

export default PromoCampaignHandlerCreate
